import React from "react";
import Eq5d5lLogo from "./components/logos/Eq5d5lLogo";
import { LCSSLogo } from "./components/logos/LCSSLogo";
import { FacitLogo } from "./components/logos/FacitLogo";
import { LCNursingLogo } from "./components/logos/LCNursingLogo";
import { MesoLogoCircle } from "./components/logos/MesoLogoCircle";

const KeysToComponentMap = {
	lcnuk: {
		logo: LCNursingLogo,
		classes: "h-12",
	},
	"eq5d-5l": {
		logo: Eq5d5lLogo,
		classes: "h-12 mt-4",
	},
	lcss: {
		logo: LCSSLogo,
		classes: "h-12 mt-1.5",
	},
	"fact-g7": {
		logo: FacitLogo,
		classes: "h-12 mt-2.5",
	},
};

function RenderLogo(code, theme) {
	if (typeof KeysToComponentMap[code] !== "undefined") {
		return React.createElement(
			KeysToComponentMap[code].logo,
			{
				classes: KeysToComponentMap[code].classes,
			},
			null
		);
	} else {
		if (theme.group === "meso" || theme.group === "mesoperitoneal") {
			return <MesoLogoCircle className={"h-14"} />;
		}

		return React.createElement(
			KeysToComponentMap["lcnuk"].logo,
			{
				classes: KeysToComponentMap["lcnuk"].classes,
			},
			null
		);
	}
}

export default RenderLogo;
